import axios from "axios";

export const NEXT = 'NEXT';
export const BACK = 'BACK';
export const SET_TOTAL = 'SET_TOTAL';
export const ADVANCE = 'ADVANCE';
export const REVERT = 'REVERT';

export const CALCULATE = 'CALCULATE';

export const RETRIEVE_RECOMMENDATIONS = 'RETRIEVE_RECOMMENDATIONS';
export const RETRIEVE_RECOMMENDATIONS_PENDING = 'RETRIEVE_RECOMMENDATIONS_PENDING';
export const RETRIEVE_RECOMMENDATIONS_FULFILLED = 'RETRIEVE_RECOMMENDATIONS_FULFILLED';
export const RETRIEVE_RECOMMENDATIONS_REJECTED = 'RETRIEVE_RECOMMENDATIONS_REJECTED';

export const next = () => ({type: NEXT});
export const back = () => ({type: BACK});
export const setTotal = (payload) => ({type: SET_TOTAL, payload});
export const advance = () => ({type: ADVANCE});
export const revert = () => ({type: REVERT});

export const calculate = (payload) => ({type: CALCULATE, payload});

export const retrieveRecommendations = () => ({
  type: RETRIEVE_RECOMMENDATIONS,
  payload: axios.get('/recommendations.json')
});

export const exportMarketoForm = (formData) => {
  window.MktoForms2.whenReady(function (form) {
    const { email: Email, ...rest } = formData;
    form.vals({ Email, ...rest });
    if (window.location.search.indexOf("debug") === -1) {
      form.submit();
    } else {
      console.log("Debug mode -- did not send to Marketo")
    }
  });
};


// WEBPACK FOOTER //
// ./src/actions/index.js